<template>
  <VCard class="my-3">
    <VList
      v-if="contracts && !contracts.length"
      two-line
      subheader
    >
      <VListTile avatar>
        <VListTileContent>
          <VListTileTitle> {{ $nt('noInfoYet') }}</VListTileTitle>
        </VListTileContent>
      </VListTile>
    </VList>

    <VDataTable
      :headers="headers"
      :items="contracts"
      class="text-xs-left"
      :loading="isLoading"
      :pagination.sync="pagination"
      :rows-per-page-items="[15]"
      :total-items="paginationTotal"
    >
      <tr
        slot="items"
        :key="props.index"
        slot-scope="props"
        @click="$router.push(linkByRole(props.item))"
      >
        <td>
          <VTooltip
            slot="badge"
            bottom
          >
            <VIcon
              slot="activator"
              :color="$vuetify.theme.accent"
            >
              warning
            </VIcon>
            <span>{{ $nt('not_subscribed') }}</span>
          </VTooltip>
        </td>
        <td>{{ props.item.elsazeit_company_name }}</td>
        <td>{{ props.item.elsazeit_user_package }}</td>
        <td class="text-xs-right">
          {{ props.item.elsazeit_user_package_cost / 100 | toEuro }}
        </td>
      </tr>
    </VDataTable>

    <VCardActions>
      <VSpacer />

      <slot />
    </VCardActions>
  </VCard>
</template>

<script>
import { toEuro } from '@/utils/customFormatters'
import PaginationApi from '@/api/PaginationApi'

export default {
  name: 'ContractsTable',
  filters: {
    toEuro
  },
  props: ['id', 'isContractsOfAgencies'],
  data () {
    return {
      isLoading: false,
      pagination: {},
      paginationTotal: 0,
      contracts: [],
      headers: [
        { text: '', value: 'subscribed', align: 'left', index: '0', sortable: false },
        { text: this.$nt('name'), value: 'elsazeit_company_name', align: 'left', index: '1', sortable: false },
        { text: this.$nt('package'), value: 'elsazeit_user_package', align: 'left', index: '2', sortable: false },
        { text: this.$nt('packageCost'), value: 'elsazeit_user_package_cost', align: 'right', index: '3', sortable: false }
      ]
    }
  },
  computed: {
    user () {
      return this.$store.getters['user/getUser']
    },
    url () {
      if (this.$can('read', 'AllContractsOfAgencies') && this.isContractsOfAgencies) {
        return `agencies/${this.id}/contracts`
      } else if (this.$can('read', 'AllContractsOfAgency')) {
        return `agency/contracts`
      } else if (this.$can('read', 'AllContractsOfAgent')) {
        return `agent/contracts`
      } else if (this.$can('read', 'AllContractsOfAgents')) {
        return `agents/${this.id}/contracts`
      }
      return null
    }
  },
  methods: {
    linkByRole (item) {
      console.log(item)

      return { name: 'contract', params: { contractId: item.id } }
      // if (this.$can('read', 'AllContractsOfAgencies') && this.isContractsOfAgencies) {
      //   // TODO: check if admin need redirect
      // } else if (this.$can('read', 'AllContractsOfAgency')) {
      //   this.$router.push({ name: 'contract', params: { contractId: id } })
      //   // TODO: check if am need redirect
      // } else if (this.$can('read', 'AllContractsOfAgent')) {
      //   this.$router.push({ name: 'contract', params: { contractId: id } })
      // }
    },
    async getPaginatedData () {
      this.isLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, undefined, this.pagination.page)
        this.paginationTotal = response.total
        this.contracts = response.data
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    }
  },
  watch: {
    pagination: {
      handler: 'getPaginatedData'
    }
  }
}
</script>
